/**
 * Cart drawer behavior (D11):
 * - open via bag icon (progressive enhancement — href stays /cart), close via
 *   backdrop / X / Esc; body scroll lock; 280ms slide via CSS .is-open
 * - quantity ± and remove per line via /cart/change.js
 * - after every mutation: /cart.js + Section Rendering re-fetch of this
 *   section → body/footer swap, bag-count badges update
 * - listens for `dylys:cart-change` (PDP add-to-cart dispatches it with
 *   opened:true) and opens with fresh content
 * - Shopify error descriptions surface inside the drawer
 */
(function () {
  'use strict';

  function init(drawer) {
    if (drawer.dataset.cartInit) return;
    drawer.dataset.cartInit = '1';

    var panel = drawer.querySelector('[data-cart-panel]');
    var errorEl = drawer.querySelector('[data-cart-drawer-error]');
    var isOpen = false;
    var busy = false;

    function setOpen(open) {
      isOpen = open;
      drawer.classList.toggle('is-open', open);
      if (panel) {
        panel.setAttribute('aria-hidden', open ? 'false' : 'true');
        if (open) panel.removeAttribute('inert');
        else panel.setAttribute('inert', '');
      }
      if (open) window.Dylys.lockScroll(); else window.Dylys.unlockScroll();
      if (open) {
        setTimeout(function () {
          var first = panel && panel.querySelector('button, a');
          if (first) first.focus();
        }, 50);
      }
    }

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message || errorEl.getAttribute('data-fallback') || '';
      errorEl.hidden = false;
    }

    function updateBadges(cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (badge) {
        badge.textContent = cart.item_count;
        badge.hidden = cart.item_count === 0;
      });
    }

    function refresh(cart, thenOpen) {
      fetch(window.location.pathname + '?sections=cart-drawer')
        .then(function (res) { return res.json(); })
        .then(function (sections) {
          var html = sections['cart-drawer'];
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          ['[data-cart-body]'].forEach(function (selector) {
            var oldEl = drawer.querySelector(selector);
            var newEl = doc.querySelector(selector);
            if (oldEl && newEl) oldEl.innerHTML = newEl.innerHTML;
          });
          // Footer appears/disappears with the empty state — swap by outerHTML
          var oldFooter = drawer.querySelector('[data-cart-footer]');
          var newFooter = doc.querySelector('[data-cart-footer]');
          if (oldFooter && newFooter) {
            oldFooter.outerHTML = newFooter.outerHTML;
          } else if (oldFooter && !newFooter) {
            oldFooter.remove();
          } else if (!oldFooter && newFooter && panel) {
            panel.appendChild(newFooter);
          }
          if (errorEl) errorEl.hidden = true;
          bindLines();
          if (cart) updateBadges(cart);
          if (thenOpen) setOpen(true);
        })
        .catch(function () { /* keep current contents */ });
    }

    function changeLine(line, quantity) {
      if (busy) return;
      busy = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (res) {
          return res.json().then(function (data) { return { ok: res.ok, data: data }; });
        })
        .then(function (result) {
          busy = false;
          if (!result.ok) {
            showError(result.data && (result.data.description || result.data.message));
            return;
          }
          document.dispatchEvent(new CustomEvent('dylys:cart-change', {
            detail: { cart: result.data, source: 'drawer' }
          }));
        })
        .catch(function () {
          busy = false;
          showError();
        });
    }

    function bindLines() {
      drawer.querySelectorAll('[data-cart-line]').forEach(function (row) {
        if (row.dataset.lineInit) return;
        row.dataset.lineInit = '1';
        var line = parseInt(row.getAttribute('data-line-index'), 10);
        var value = row.querySelector('.cart-line__qty-value');
        var read = function () { return parseInt(value ? value.textContent : '1', 10) || 1; };

        var dec = row.querySelector('[data-line-decrease]');
        var inc = row.querySelector('[data-line-increase]');
        var rem = row.querySelector('[data-line-remove]');
        if (dec) dec.addEventListener('click', function () { changeLine(line, Math.max(0, read() - 1)); });
        if (inc) inc.addEventListener('click', function () { changeLine(line, read() + 1); });
        if (rem) rem.addEventListener('click', function () { changeLine(line, 0); });
      });
    }

    drawer.querySelectorAll('[data-cart-close]').forEach(function (el) {
      el.addEventListener('click', function () { setOpen(false); });
    });

    window.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) setOpen(false);
    });

    // Bag icons open the drawer instead of navigating
    document.querySelectorAll('[data-cart-icon]').forEach(function (icon) {
      icon.addEventListener('click', function (e) {
        e.preventDefault();
        refresh(null, true);
        setOpen(true);
      });
    });

    // Cart mutations from anywhere (PDP add-to-cart, cart page)
    document.addEventListener('dylys:cart-change', function (e) {
      var cart = e.detail && e.detail.cart;
      var opened = !!(e.detail && e.detail.opened);
      refresh(cart, opened || isOpen);
      if (cart) updateBadges(cart);
    });

    bindLines();

    window.Dylys = window.Dylys || {};
    window.Dylys.cartDrawer = {
      open: function () { refresh(null, true); setOpen(true); },
      close: function () { setOpen(false); }
    };
  }

  function initAll() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (drawer) init(drawer);
  }

  initAll();

  document.addEventListener('shopify:section:load', initAll);
})();
